import { useMemo, useState } from 'react';
import Lightbox from '../../../components/ui/Lightbox/Lightbox';
import './ProjectGallery.css';

const CATEGORY_LABELS = {
  exterior: 'Exterior',
  interior: 'Interior',
  amenities: 'Amenities',
  'floor-plans': 'Floor Plans',
};

export default function ProjectGallery({ project }) {
  const images = useMemo(() => project.gallery || [], [project.gallery]);
  const [active, setActive] = useState(null);
  const [filter, setFilter] = useState('all');

  const categories = useMemo(() => {
    const present = [...new Set(images.map((i) => i.category).filter(Boolean))];
    return present.length > 1 ? ['all', ...present] : [];
  }, [images]);

  const shown = filter === 'all' ? images : images.filter((i) => i.category === filter);

  if (!images.length) return null;

  return (
    <section id="gallery" className="pd-section pd-gallery">
      <p className="pd-eyebrow">Gallery</p>
      <h2 className="pd-title">Inside the <em>development</em></h2>

      {categories.length > 0 && (
        <div className="pd-gallery__tabs" role="tablist">
          {categories.map((c) => (
            <button
              key={c}
              role="tab"
              aria-selected={filter === c}
              className={`pd-gallery__tab${filter === c ? ' is-active' : ''}`}
              onClick={() => setFilter(c)}
            >
              {c === 'all' ? 'All' : CATEGORY_LABELS[c] || c}
            </button>
          ))}
        </div>
      )}

      <div className="pd-gallery__grid">
        {shown.map((img, i) => (
          <button
            key={img.src}
            className={`pd-gallery__item${i === 0 ? ' pd-gallery__item--lead' : ''}`}
            onClick={() => setActive(images.indexOf(img))}
            aria-label={`View image: ${img.alt || 'project image'}`}
          >
            <img src={img.src} alt={img.alt || ''} loading="lazy" />
          </button>
        ))}
      </div>

      <Lightbox
        items={images.map((i) => ({ src: i.src, alt: i.alt, caption: i.alt }))}
        index={active}
        onClose={() => setActive(null)}
        onNavigate={setActive}
      />
    </section>
  );
}
